var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1874 56.75L46.4286 38M28.5714 38L7.81261 56.75M6.25 22.375L31.7654 40.2358C33.8315 41.6821 34.8646 42.4052 35.9883 42.6853C36.9809 42.9328 38.0191 42.9328 39.0117 42.6853C40.1354 42.4052 41.1685 41.6821 43.2346 40.2358L68.75 22.375M21.25 63H53.75C59.0005 63 61.6257 63 63.6312 61.9782C65.3952 61.0794 66.8294 59.6452 67.7282 57.8812C68.75 55.8757 68.75 53.2505 68.75 48V28C68.75 22.7495 68.75 20.1243 67.7282 18.1188C66.8294 16.3548 65.3952 14.9206 63.6312 14.0218C61.6257 13 59.0005 13 53.75 13H21.25C15.9995 13 13.3743 13 11.3688 14.0218C9.60482 14.9206 8.17063 16.3548 7.27181 18.1188C6.25 20.1243 6.25 22.7495 6.25 28V48C6.25 53.2505 6.25 55.8757 7.27181 57.8812C8.17063 59.6452 9.60482 61.0794 11.3688 61.9782C13.3743 63 15.9995 63 21.25 63Z",
    stroke: "#6E56CF",
    strokeWidth: 4.98438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8c2ea42f231642af228257e857d5d447.svg";
export { ForwardRef as ReactComponent };